<script setup>
import { cn } from "@/lib/utils";
import { DropdownMenuSeparator } from "reka-ui";
import { computed } from "vue";

const props = defineProps({
  class: {
    type: [String, Array, Object],
    default: "",
  },
});

const delegatedProps = computed(() => {
  // eslint-disable-next-line no-unused-vars
  const { class: _, ...delegated } = props;
  return delegated;
});
</script>

<template>
  <DropdownMenuSeparator
    v-bind="delegatedProps"
    :class="cn('vf--mx-1 vf-my-1 vf-h-px vf-bg-muted', props.class)"
  />
</template>
